import { css } from "styled-components";

export const enum DrawerPlacementType {
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
}

export const DragPlacementMap = new Map([
  [
    DrawerPlacementType.Top,
    css`
      bottom: 4px;
    `,
  ],
  [
    DrawerPlacementType.Bottom,
    css`
      top: 4px;
    `,
  ],
  [
    DrawerPlacementType.Left,
    css`
      right: 4px;
    `,
  ],
  [
    DrawerPlacementType.Right,
    css`
      left: 4px;
    `,
  ],
]);

export const DragButtonWrapperPlacementMap = new Map([
  [
    DrawerPlacementType.Top,
    css`
      width: 100%;
      height: 7px;
      bottom: 0;
      cursor: ns-resize;
    `,
  ],
  [
    DrawerPlacementType.Bottom,
    css`
      width: 100%;
      height: 7px;
      top: 0;
      cursor: ns-resize;
    `,
  ],
  [
    DrawerPlacementType.Left,
    css`
      width: 7px;
      height: 100%;
      right: 0;
      cursor: ew-resize;
    `,
  ],
  [
    DrawerPlacementType.Right,
    css`
      width: 7px;
      height: 100%;
      left: 0;
      cursor: ew-resize;
    `,
  ],
]);

export const DragButtonPlacementMap = new Map([
  [
    DrawerPlacementType.Top,
    css`
      width: 60px;
      height: 3px;
      bottom: 4px;
      left: calc(50% - 30px);
    `,
  ],
  [
    DrawerPlacementType.Bottom,
    css`
      width: 60px;
      height: 3px;
      top: 4px;
      left: calc(50% - 30px);
    `,
  ],
  [
    DrawerPlacementType.Left,
    css`
      width: 3px;
      height: 60px;
      right: 4px;
      top: calc(50% - 30px);
    `,
  ],
  [
    DrawerPlacementType.Right,
    css`
      width: 3px;
      height: 60px;
      left: 4px;
      top: calc(50% - 30px);
    `,
  ],
]);
